import { react2angular } from 'react2angular';

import { BuyerAgreementCheckbox } from 'components';
import {
  brokerbayFocusOnClick,
  brokerbayFocusOnClickButton,
  brokerbayFocusOnClickElement,
} from './focus_on_click.directive';
import brokerbayMobileSetHeight from './mobile_set_height.directive';
import LockboxPhotoEditor from '../../react-common/LockboxPhotoEditor';
import LockboxAccessLogs from './LockboxAccessLogs';
import ShowingSettings from './ShowingSettings';
import SaveButtonWithMixpanel from './SaveButtonWithMixpanel';
import VirtualShowingSettings from './VirtualShowingSettings';
import ShowingAgentInstructions from './ShowingAgentInstructions';
import appointmentConfigSwitcher from './AppointmentConfigSwitcher';
import covid19Settings from './Covid19Settings';
import covid19AptAction from '../../covid19/COVID19AptAction';
import { ConfigContactModalAngularComponent } from '../../../Router/ConfigContactModal/forAngular/ConfigConactModalAngularComponent';
import { AnsweringServiceSettings as answeringServiceSettings } from './AnsweringServiceSettings';

angular
  .module('bb.appointments', [
    'bb.users',
    'ngRoute',
    'bb.util',
    'bb.listing',
    'bb.external',
    'bb.appointments.feedback',
    'bb.appointments.virtual_tour_list',
  ])
  .component(
    'bbLockboxPhotoEditor',
    react2angular(
      LockboxPhotoEditor,
      ['visible', 'closeModal', 'onSave', 'lockboxPhoto', 'isRemovable'],
      ['$rootScope', 'ToastService'],
    ),
  )
  .component(
    'bbShowingSettings',
    react2angular(ShowingSettings, [
      'advAutoConfEnabled',
      'scrollToAptRestrictions',
      'notice',
      'noticeMinutes',
      'overnightNotice',
      'maxDuration',
      'doubleBookings',
      'maxOverlap',
      'bufferSlots',
      'notifyOverlappingAppt',
      'showingInstructions',
      'showVendorInstructions',
      'vendorInstructions',
      'approveShowingOptions',
      'setShowingSettings',
      'setAgentOnlyConfirm',
      'noMoreShowings',
      'setIsMustCallDisabled',
      'auth',
    ]),
  )
  .component(
    'bbSaveButtonWithMixpanel',
    react2angular(SaveButtonWithMixpanel, [
      'form',
      'submit',
      'disabled',
      'auth',
      'additionalClass',
    ]),
  )
  .component(
    'bbShowingAgentInstructions',
    react2angular(
      ShowingAgentInstructions,
      [
        'accessesMap',
        'appointmentConfig',
        'lockboxPhoto',
        'openFileUpload',
        'areAppointmentInstructionsInvalid',
        'setShowingAgentInstructions',
        'changeDisplayToSellerToggle',
        // sentriLock validator props
        'setGetLockboxesFalse',
        'shouldGetLockboxes',
        'listingId',
        'listingReps',
        'listingOrgFeatures',
        'mlsNumbers',
        'sentriLockInfo',
        'setSentriLockInfo',
        // masterLock Validator props
        'resetAppointmentConfigAccess',
        'setIsMasterLockCodeValid',
        'setIsMasterLockOneDayCodeEnabled',
        'onValidate',
        'deviceId',
        'setIsSupraLockCodeValid',
        'supraLockInfo',
        'setSupraLockInfo',
        'showSupraAccessOptions',
        'showMasterLockAccessOptions',
        'showSentriLockAccessOptions',
        'showCombinationLockboxOptions',
      ],
      ['$rootScope', 'ToastService'],
    ),
  )
  .component(
    'bbVirtualShowingSettings',
    react2angular(VirtualShowingSettings, [
      'virtualTourEnabled',
      'virtualTourProvider',
      'virtualTourIdentifier',
      'setVirtualTourData',
    ]),
  )
  .component(
    'bbLockboxAccessLogs',
    react2angular(LockboxAccessLogs, ['lockboxType', 'deviceId', 'date']),
  )
  .component(
    'appointmentConfigSwitcher',
    react2angular(
      appointmentConfigSwitcher,
      ['toggle', 'answeringSubscriptionExists'],
      ['$rootScope'],
    ),
  )
  .component(
    'appointmentCovid19Settings',
    react2angular(covid19Settings, ['listingId']),
  )
  .component(
    'appointmentAnsweringServiceSettings',
    react2angular(answeringServiceSettings, [
      'listingId',
      'useAppointmentDeskInitial',
      'toggleUseAppointmentDesk',
      'answeringServicePhone',
    ]),
  )
  .component(
    'covid19AptAction',
    react2angular(covid19AptAction, [
      'appointment',
      'updateAppointment',
      'showLinkOnly',
      'isNonAdminListingAgent',
    ]),
  )
  .component(
    'configContactModal',
    react2angular(
      ConfigContactModalAngularComponent,
      [
        'contact',
        'contacts',
        'isProfile',
        'userId',
        'isSaving',
        'listingId',
        'listing',
        'visible',
        'onClose',
        'onSave',
      ],
      ['$rootScope'],
    ),
  )
  .component(
    'bbBuyerAgreementCheckbox',
    react2angular(BuyerAgreementCheckbox, [], []),
  )
  .directive('brokerbayFocusOnClick', brokerbayFocusOnClick)
  .directive('brokerbayFocusOnClickButton', brokerbayFocusOnClickButton)
  .directive('brokerbayFocusOnClickElement', brokerbayFocusOnClickElement)
  .directive('brokerbayMobileSetHeight', brokerbayMobileSetHeight);

require('./feedback/feedback.module');
require('./virtual_tour_list/virtual_tour_list.module');

require('./appointment_watch.service');
require('./appointment_list.service');
require('./appointment_status.service');
require('./appointment_book.service');
require('./appointment_config.service');

require('./appointment_book.component');
require('./appointment_time_change.component');
require('./appointment_config_contacts.component');
require('./multi_conf_modal.component');
require('./appointment_list.component');

require('./appointment_phone_number');
require('./appointment_watch.controller');
require('./appointment_action.component');
require('./appointment_confirm.component');
require('./appointment_deny.component');
require('./appointment_cancel.component');
require('./appointment_config.component');
require('./appointment_config_modal.component');
require('./appointment_status_change.component');
require('./appointment_restrictions.component');

require('./appointment_notify_by.directive');
require('./appointment_users_viewing.directive');
require('./delivery_method.directive');
require('./appointment_paginate.directive');

require('../preview/appointment_preview_button.component');
require('../preview/appointment_modal.component');

require('./email_delivery_log.component.ts');
require('./sms_delivery_log.component');
require('./push_delivery_log.component');

require('./updateExistingShowingsModal.component');

require('./appointments.routes');
